import { isTestEndpoint } from "../../../state/modules/config/selectors";
import { LOYALTY_TIER_QUERY } from "../constants";

export default ({
  baseUrl,
  country,
  language,
  xSiteOrigin,
  loyaltyTier,
  fullCategoryTree,
}) => {
  const { siteId, countryCode, keyStoreDataversion } = country;

  const defaultParams = {
    store: siteId,
    lang: language,
    depth: 1,
    country: countryCode,
    keyStoreDataversion,
  };

  if (fullCategoryTree) {
    delete defaultParams.depth;
  }

  if (isTestEndpoint(baseUrl)) {
    defaultParams["x-site-origin"] = xSiteOrigin;
  }

  if (loyaltyTier) {
    defaultParams[LOYALTY_TIER_QUERY] = loyaltyTier;
  }

  return defaultParams;
};
